/* =========================================================
   7 A.M. — Gesto de énfasis
   ---------------------------------------------------------
   El sistema marca una frase dentro de un titular con UN trazo
   continuo de pluma: va a la derecha, vuelve a la izquierda y
   barre otra vez a la derecha. Tres pasadas en un solo path.

   Y se dibuja solo. Como es un único path, animar
   stroke-dashoffset de su longitud a cero reproduce el gesto en
   el orden en que se hizo. Eso exige un <svg> hermano del
   texto, así que no se puede resolver con background-image:
   hay que inyectarlo.

   El contenido lo escribe el comerciante en el CMS marcando la
   frase con <span class="accent">. Este script asciende ese
   span a .t-gesture y le mete el trazo.

   Sobre el pliegue el trazo corre al cargar. Por debajo se
   retiene sin pintar hasta que el titular entra en pantalla,
   para que el gesto no se pierda.

   Una frase por titular: si todo va enfatizado, no lo va nada.
   ========================================================= */
(function () {
  "use strict";

  // El path mide 643,39 unidades y el dasharray de design-tokens.css es 644.
  // Si se edita, hay que volver a medirlo con getTotalLength().
  var PATH =
    "M3 10.6236C44 4.79031 150 -1.25252 260.5 7.12364C208.167 6.12365 88.6 " +
    "6.92369 29 18.1237C59.5 15.6237 132 12.2476 182 22.1237";

  var HEADINGS = [
    ".hero__title",
    ".section-title",
    ".cathead__title",
    ".info__title",
    ".subscribe__title",
    ".t-display",
    ".t-h1",
    ".t-h2",
  ].join(",");

  function drawSvg() {
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 264 25");
    svg.setAttribute("preserveAspectRatio", "none");
    svg.setAttribute("aria-hidden", "true");
    var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", PATH);
    path.setAttribute("fill", "none");
    path.setAttribute("stroke-linecap", "round");
    path.setAttribute("stroke-linejoin", "round");
    svg.appendChild(path);
    return svg;
  }

  // Sobre fotografía oscura el crema profundo se enfanga contra la imagen: el
  // sistema sube un paso vía .t-gesture--dark.
  function onDarkGround(el) {
    var node = el;
    while (node && node !== document.body) {
      if (node.dataset && node.dataset.dsGround === "dark") return true;
      var c = node.className;
      if (typeof c === "string" && /--photo|--dark|hero__media|is-inverse/.test(c)) {
        return true;
      }
      node = node.parentElement;
    }
    // Último recurso: si el titular es claro, el fondo es oscuro.
    var color = window.getComputedStyle(el).color;
    var m = color.match(/\d+/g);
    return !!m && (Number(m[0]) + Number(m[1]) + Number(m[2])) / 3 > 170;
  }

  function upgrade(heading) {
    // Una por titular: solo el primer .accent.
    var span = heading.querySelector(".accent:not(.t-gesture)");
    if (!span) return;

    span.classList.add("t-gesture");
    if (onDarkGround(heading)) span.classList.add("t-gesture--dark");
    // El trazo necesita aire bajo la línea base o choca con la línea siguiente.
    heading.classList.add("t-has-gesture");
    span.appendChild(drawSvg());
    return span;
  }

  function init() {
    var headings = document.querySelectorAll(HEADINGS);
    var deferred = [];

    headings.forEach(function (heading) {
      var span = upgrade(heading);
      if (!span) return;
      // Por debajo del pliegue el trazo espera a entrar en pantalla.
      if (heading.getBoundingClientRect().top > window.innerHeight) {
        span.classList.add("t-gesture--onscroll");
        deferred.push(span);
      }
    });

    if (!deferred.length || !("IntersectionObserver" in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-drawn");
          io.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -15% 0px" }
    );
    deferred.forEach(function (span) {
      io.observe(span);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
